let timeout = null;
let interval = null;

function getLegalNav () {
  const header = document.querySelector('.oxg-header');
  const headerContent = document.querySelector('.oxg-header-inner-wrap');
  const legalNav = document.getElementById('oxg-legal-nav');
  return {
    header: header,
    headerContent: headerContent,
    legalNav: legalNav
  }
}

function setLegalNavClasses(header, headerContent, legalNav) {
  if (header.offsetHeight < headerContent.offsetHeight + legalNav.offsetHeight) {
    legalNav.classList.add('pos-origin-bottom');
    legalNav.classList.remove('pos-origin-top');
  } else {
    legalNav.classList.remove('pos-origin-bottom');
    legalNav.classList.add('pos-origin-top');
  }
}

const resize = ()=> {
  positionLegalNav();
}

function positionLegalNav() {
  let elements = getLegalNav();
  if(!elements.header || !elements.legalNav) return;
  setLegalNavClasses(elements.header, elements.headerContent, elements.legalNav);
}

window.addEventListener('resize', ()=> {
  requestAnimationFrame(resize);
});

document.addEventListener('appFrameSet', () => {
  positionLegalNav();
  clearInterval(interval);
  interval = setInterval(()=> {
    positionLegalNav();
  }, 10);
  clearTimeout(timeout);
  timeout = setTimeout(()=> {
    clearInterval(interval);
  }, 50);
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      scrollMenutItemIntoView();
    });
  });
});

document.addEventListener('scrolledToCurrentMenuItem', () => {
  positionLegalNav();
});



function scrollMenutItemIntoView() {
  let scrollContainer = document.querySelector('.oxg-header');
  if (!scrollContainer) return;
  let currentMenuItem = scrollContainer.querySelector('.current-menu-item');
  if(currentMenuItem) {
    let offset = -50;
    console.log('scrollContainer.clientHeight', scrollContainer.clientHeight)
    console.log('currentMenuItem.offsetTop', currentMenuItem.offsetTop)
    let top = currentMenuItem.offsetTop - scrollContainer.clientHeight / 2 + offset;
    console.log('scrolling header to:', top);
    scrollContainer.scrollTo({ top, behavior: 'smooth' });
    document.dispatchEvent(new CustomEvent("scrolledToCurrentMenuItem"));
  }
}

document.addEventListener('scrolledToCurrentMenuItem', () => {
  console.log('event fired scrolledToCurrentMenuItem')
});